(function() {
  'use strict';

  function RelationsController(
    RouterHelper, Profile, Relations, RelationSearch, List, Security, $translate, Utils
  ) {
    var ctrl = this;
    ctrl.options = {
      trackBy: 'doc._id'
    };

    Utils.setPageTitle('Relations');

    ctrl.searchModel = Profile.getListPreferences('relations').current;

    ctrl.list = new List({
      search: RelationSearch.search,
      model: ctrl.searchModel,
      idField: 'doc._id'
    }
    );

    Relations.findAll({ cached: false })
      .then(function(data) {
        ctrl.list.doLoadItems(data);
      });

    ctrl.actions = [
      {
        label: $translate.instant('Reorder'),
        icon: 'icon-move',
        route: ['/relations/reorder'],
        showCondition: Security.hasPermission.bind(this, 'relations.edit'),
        klass: 'btn-border btn-info'
      },
      {
        label: $translate.instant('New relation'),
        icon: 'icon-edit',
        route: ['/relations/new'],
        showCondition: Security.hasPermission.bind(this, 'relations.edit'),
        klass: 'btn-success'
      }
    ];

    // Defined here so that I don't have to create a special slot that does nothing
    ctrl.options.actionButtons = function(item) {
      return [
        {
          label: $translate.instant('Edit'),
          icon: 'icon-edit',
          route: ['/relations/edit', item.doc._id],
          showCondition: Security.hasPermission.bind(this, 'relations.edit'),
          klass: 'text-info'
        },
        {
          label: $translate.instant('View'),
          icon: 'icon-edit',
          route: ['/relations/edit', item.doc._id],
          showCondition: function() {
            return Security.hasPermission('relations.edit')
              .then(function(has) {
                return !has;
              })
              .catch(function() {
                return true;
              });
          },
          klass: 'text-info'
        }
      ];
    };

    ctrl.options.secondaryActionButtons = function(item) {
      return [
        {
          label: $translate.instant('Duplicate'),
          icon: 'icon-duplicate',
          onClick: function() {
            Relations.getNewCopy(item.doc._id)
              .then(function(newCopy) {
                RouterHelper.navigate(['/relations/new'],
                  { state: { template: newCopy } }
                );
              });
          },
          showCondition: Security.hasPermission.bind(this, 'relations.edit'),
          klass: 'text-info'
        }
      ];
    };
  }

  RelationsController.$inject = [
    'RouterHelperService',
    'ProfileService',
    'RelationsService',
    'RelationSearch',
    'ListFactory',
    'SecurityService',
    '$translate',
    'UtilsService'
  ];

  angular.module('component.relations')
    .component('relationsList', {
      templateUrl: 'app/components/relations/list.html',
      controller: RelationsController,
      controllerAs: 'relationsCtrl'
    });
})();
